/**
 * 전화번호 포맷팅 유틸
 *
 * 010-1234-5678 형식으로 자동 포맷팅
 */

/** 숫자만 추출 */
function digitsOnly(value: string): string {
  return value.replace(/\D/g, "");
}

/** 전화번호 포맷: 01012345678 → 010-1234-5678 */
export function formatPhoneNumber(value: string): string {
  const digits = digitsOnly(value);
  if (digits.length <= 3) return digits;
  if (digits.length <= 7) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 7)}-${digits.slice(7, 11)}`;
}

/** 포맷된 전화번호에서 숫자만 추출: 010-1234-5678 → 01012345678 */
export function unformatPhoneNumber(value: string): string {
  return digitsOnly(value);
}
